import general from "./en/general";

export  default {
    general,
}
